// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-box__content {
  flex: 1;
  padding: 5px 10px;
}

.info-box__icon {
  background: #0003;
  border-radius: 2px 0 0 2px;
  flex: 0 0 90px;
  justify-content: center;
  align-items: center;
  font-size: 45px;
  line-height: 90px;
  display: flex;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.info-box__wrapper {
  color: #fff;
  background: none;
  border-radius: 2px;
  width: 100%;
  min-height: 90px;
  margin-bottom: 20px;
  display: flex;
  box-shadow: 0 1px 1px #0000001a;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.info-box__wrapper--aqua {
  background: #3488a9;
}

.info-box__wrapper--green {
  background: #008a60;
}

.info-box__wrapper--maroon {
  background: #845863;
}

.info-box__wrapper--colorize {
  color: var(--text-color);
  background: #777;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/InfoBox/InfoBox.css","webpack://./services/frontend/app/components/InfoBox/InfoBox.css"],"names":[],"mappings":"AADA;ECEE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB","sourcesContent":[".info-box__content {\n  flex: 1;\n  padding: 5px 10px;\n}\n\n.info-box__icon {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 2px 0 0 2px;\n  display: flex;\n  flex: 0 0 90px;\n  font-size: 45px;\n  justify-content: center;\n  line-height: 90px;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.info-box__wrapper {\n  background: none;\n  border-radius: 2px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n  color: #fff;\n  display: flex;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  min-height: 90px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.info-box__wrapper--aqua {\n  background: #3488a9;\n}\n\n.info-box__wrapper--green {\n  background: #008a60;\n}\n\n.info-box__wrapper--maroon {\n  background: #845863;\n}\n\n.info-box__wrapper--colorize {\n  background: #777;\n  color: var(--text-color);\n}\n",".info-box__content {\n  flex: 1;\n  padding: 5px 10px;\n}\n\n.info-box__icon {\n  background: #0003;\n  border-radius: 2px 0 0 2px;\n  flex: 0 0 90px;\n  justify-content: center;\n  align-items: center;\n  font-size: 45px;\n  line-height: 90px;\n  display: flex;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.info-box__wrapper {\n  color: #fff;\n  background: none;\n  border-radius: 2px;\n  width: 100%;\n  min-height: 90px;\n  margin-bottom: 20px;\n  display: flex;\n  box-shadow: 0 1px 1px #0000001a;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.info-box__wrapper--aqua {\n  background: #3488a9;\n}\n\n.info-box__wrapper--green {\n  background: #008a60;\n}\n\n.info-box__wrapper--maroon {\n  background: #845863;\n}\n\n.info-box__wrapper--colorize {\n  color: var(--text-color);\n  background: #777;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
